module.exports = __webpack_public_path__ + "img/city.a4bb6fbe.png";